// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1R7km","gfeWrapper":"CalendarEvent_gfeWrapper__8kEC4"};